import React from "react";
export function ContactInfo() {
  return (
    <section className="flex justify-center gap-2 font-medium">
      <h2>(862)235-0801</h2>|<h2>329 16th Ave, Irvington, NJ 07111</h2>
    </section>
  );
}
